import { customElement } from "lit/decorators.js";
import { MessageFormPage } from "../message-form-page/message-form-page";
import { t } from "../../translations/i18n";

@customElement("edit-message-page")
export class EditMessagePage extends MessageFormPage {
  get mode() {
    return "edit" as const;
  }

  get pageTitle() {
    return t("creatorMessages.editTitle");
  }

  get pageSubtitle() {
    return t("creatorMessages.createSubtitle");
  }

  override connectedCallback(): void {
    super.connectedCallback();
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const editIndex = pathSegments.indexOf("edit");
    const messageId = editIndex !== -1 ? pathSegments[editIndex + 1] : undefined;
    if (messageId) {
      this.authState.ready.then(() => this.formService.loadMessage(messageId));
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "edit-message-page": EditMessagePage;
  }
}
